document.addEventListener("DOMContentLoaded", function () {
    // Select all swatch labels
    const swatchLabels = document.querySelectorAll('.product__color-swatches--js');

    swatchLabels.forEach((label) => {
        // Get the value of "data-value" attribute
        const textValue = label.getAttribute('data-value');

        if (textValue) {
            // Create a span element to hold the text
            const textSpan = document.createElement('span');
            textSpan.textContent = textValue;

            // Add styling for the text
            textSpan.style.display = 'block';
            textSpan.style.textAlign = 'center';
            textSpan.style.marginBottom = '5px'; // Space between text and the swatch
            textSpan.style.fontSize = '14px';
            textSpan.style.fontWeight = 'bold';
            textSpan.style.color = '#000';

            // Wrap the label and span in a container for better alignment
            const wrapper = document.createElement('div');
            wrapper.style.display = 'flex';
            wrapper.style.flexDirection = 'column';
            wrapper.style.alignItems = 'center';

            // Move the label into the wrapper and append the textSpan
            label.parentNode.insertBefore(wrapper, label);
            wrapper.appendChild(textSpan);
            wrapper.appendChild(label);
        }
    });
});